import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styles from "./LanguageSwitcher.module.css";

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const languages = useMemo(() => ["en", "pl", "de", "fr", "es", "zh", "ja"], []);
    const getBase = (lng) => (lng || "").toLowerCase().split("-")[0];

    const currentBase = getBase(i18n.resolvedLanguage || i18n.language || "en");
    const activeIndex = Math.max(0, languages.indexOf(currentBase));

    const changeLanguage = (idx) => {
        const base = languages[idx];
        if (!base) return;
        i18n.changeLanguage(base);
        localStorage.setItem("lang", base);
    };

    return (
        <div
            className={styles.root}
            role="radiogroup"
            aria-label="Language"
            style={{ "--count": languages.length, "--index": activeIndex }}
        >
            {languages.map((code, idx) => {
                const isActive = idx === activeIndex;
                return (
                    <button
                        key={code}
                        type="button"
                        role="radio"
                        aria-checked={isActive}
                        className={`${styles.item} ${isActive ? styles.on : styles.off}`}
                        onClick={() => changeLanguage(idx)}
                    >
                        {code.toUpperCase()}
                    </button>
                );
            })}
            <div className={styles.indicator} aria-hidden="true" />
        </div>
    );
}
